interface CountCellProps {
  value: number
}

export function CountCell({ value }: CountCellProps) {
  return (
    <div className="flex h-7 items-center">
      <span className="text-sm text-gray-500">{value}</span>
    </div>
  )
}
